// JSON-LD builders for schema.org structured data. Each returns a plain object
// meant to be embedded via <script type="application/ld+json">{JSON.stringify(...)}</script>
// inside a page's <Helmet>. Kept centralized so every page describes the same
// site consistently (name, url) instead of re-typing it per page.
const SITE_URL = "https://www.ilovemathworksheets.com";
const SITE_NAME = "iLoveMathWorksheets";

// No SearchAction here: schema.org's contract for it is that the target URL
// must actually return results for {search_term_string} when visited — /topics
// has no query-string-driven search (only an in-page filter), so a SearchAction
// would describe functionality that doesn't exist.
export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
  };
}

// items: [{ name, path }] in order from the site root. path is relative
// ("/", "/grade/3") and gets resolved against SITE_URL here.
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function courseSchema({ name, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    name,
    description,
    url: `${SITE_URL}${path}`,
    provider: {
      "@type": "EducationalOrganization",
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}
